import { UserService } from './../../../../services/user.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { AlertService } from 'services/alert.service';
import { FriendDetailsService } from 'services/frienddetails.service';
import { VoucherService } from 'services/voucher.service';
import { NavigationService } from 'services/navigation.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-voucher',
  templateUrl: './voucher.component.html',
  styleUrls: ['./voucher.component.scss']
})
export class VoucherComponent implements OnInit {
  form: FormGroup;
  dropdownSettings: { singleSelection: boolean; idField: string; textField: string; selectAllText: string; unSelectAllText: string; itemsShowLimit: number; allowSearchFilter: boolean; };
  accountTypeList: any;
  bankList: any[];
  branchCode: any;
  VendorImageList: any;

  constructor(private formBuilder: FormBuilder,
    private navigationService: NavigationService,
    private alertService: AlertService,
    private UserService: UserService,
    private VoucherService: VoucherService,
    private friendDetailsService:FriendDetailsService,

  ) {

  
   }

  ngOnInit() {
   this.getVoucherDetails(true);
  }
  
  Vendor(id) {
    debugger;
    this.VoucherService.vendorname = id;
    this.VoucherService.path = 0;
   this.navigationService.goVouchernameList();
   
}
  getVoucherDetails(refresh) {
    this.UserService.getVendorImg( refresh).subscribe(user => {
      this.VendorImageList = user.data.vendors;
      this.VoucherService.VendorList = user.data.vendors;
    });
  }

  goBack()
  {
    this.navigationService.goToDashboard();
  }

  validateFormControl() {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      }
    })
  }

  
}
